"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ClockCircleOutlined = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/ClockCircleOutlined"));

var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return _react.default.createElement(_AntdIcon.default, Object.assign({}, props, {
    ref: ref,
    icon: _ClockCircleOutlined.default
  }));
};

ClockCircleOutlined.displayName = 'ClockCircleOutlined';

var _default = _react.default.forwardRef(ClockCircleOutlined);

exports.default = _default;